<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="平台活动名称">
          <el-input placeholder="请输入平台活动名称" v-model="formInline.search">
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加平台活动</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="平台活动名称"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">查看报名人数</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :platform_activity_id="platform_activity_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!-- 报名人数弹窗 -->
    <el-dialog
      title="报名人数详情"
      :visible.sync="signupDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-loading="signupLoading">
        <el-table :data="signupList" border style="width: 100%">
          <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column>
          <el-table-column label="头像" width="80">
            <template slot-scope="scope">
              <el-avatar :size="40" :src="scope.row.avatarUrl || '/static/default-avatar.png'"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="昵称"></el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
          <el-table-column prop="company_name" label="公司名称"></el-table-column>
          <el-table-column prop="post" label="职位"></el-table-column>
          <el-table-column label="报名时间" width="140">
            <template slot-scope="scope">
              {{ formatTime(scope.row.create_time) }}
            </template>
          </el-table-column>
        </el-table>
        
        <div class="signup-summary">
          <p>总报名人数：<strong>{{ signupList.length }}</strong> 人</p>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="signupDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
  import Platform_activityApi from '@/api/platform_activity.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },
        bmNum:[],

        open_add:false,
        open_edit:false,
        platform_activity_id:"",
        dialogVisible:false,
        
        // 报名人数相关数据
        signupDialogVisible: false,
        signupLoading: false,
        signupList: [],
        currentActivity: null
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//平台活动标题设置
        this.dialogVisible = true;
      },
      
      // 查看报名人数
      detailClick(row){
        this.currentActivity = row;
        this.getSignupData(row.platform_activity_id);
      },
      
      // 获取报名数据
      getSignupData(platform_activity_id) {
        this.signupLoading = true;
        this.signupDialogVisible = true;
        
        Platform_activityApi.bmNum({platform_activity_id: platform_activity_id}, true)
          .then(data => {
            this.signupLoading = false;
            if (data.code === 1) {
              // 处理接口返回的数据结构
              this.processSignupData(data.data);
            } else {
              this.$message.error('获取报名数据失败');
            }
          })
          .catch(error => {
            this.signupLoading = false;
            this.$message.error('获取报名数据失败');
          });
      },
      
      // 处理报名数据
      processSignupData(data) {
        this.signupList = [];
        
        // 遍历数据对象，找到包含用户信息的数组
        Object.keys(data).forEach(key => {
          if (Array.isArray(data[key])) {
            // 找到用户数组
            const userArray = data[key];
            userArray.forEach(user => {
              // 找到对应的报名记录
              const signupRecord = Object.values(data).find(item => 
                item && typeof item === 'object' && item.user_id === user.user_id
              );
              
              if (signupRecord) {
                this.signupList.push({
                  ...user,
                  create_time: signupRecord.create_time
                });
              }
            });
          }
        });
        
        // 如果没有找到用户数据，尝试直接使用接口返回的数据
        if (this.signupList.length === 0) {
          Object.keys(data).forEach(key => {
            if (data[key] && typeof data[key] === 'object' && data[key].user_id) {
              this.signupList.push(data[key]);
            }
          });
        }
      },
      
      // 格式化时间戳
      formatTime(timestamp) {
        if (!timestamp) return '-';
        const date = new Date(timestamp * 1000);
        return date.toLocaleString();
      },
      
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
      
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Platform_activityApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true;
      },

      /*编辑活动*/
      editClick(row) {
        this.platform_activity_id = row.platform_activity_id;
        this.open_edit = true;
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Platform_activityApi.del(
              {
                platform_activity_id: row.platform_activity_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('删除失败');
                }
              })
              .catch(error => {
                self.$message.error('删除失败');
              });
          })
          .catch(() => {});
      }
    }
  };
</script>

<style>
  .signup-summary {
    margin-top: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    text-align: center;
  }
  
  .signup-summary p {
    margin: 0;
    font-size: 14px;
    color: #606266;
  }
  
  .signup-summary strong {
    color: #409EFF;
    font-size: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/views/plus/platform_activity/index/index.vue